import * as CryptoJS from 'crypto-js';

export class PkceUtils {
    private static readonly BYTE_LENGTH: number = 64;

    public static generateCodeChallengeAndCodeVerifier() {
        const codeVerifier = PkceUtils.generateRandomString();
        const codeChallenge = PkceUtils.generateCodeChallenge(codeVerifier);

        return {
            codeVerifier,
            codeChallenge,
        };
    }

    private static generateRandomString() {
        const randomString = CryptoJS.lib.WordArray.random(PkceUtils.BYTE_LENGTH);

        return CryptoJS.enc.Hex.stringify(randomString);
    }

    private static generateCodeChallenge(codeVerifier: string) {
        const hash = CryptoJS.SHA256(codeVerifier).toString(CryptoJS.enc.Base64);

        return PkceUtils.base64UrlEncode(hash);
    }

    private static base64UrlEncode(value: string) {
        return value.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
    }
}
